{
  "about": {
    "imprint": "about.imprint",
    "partner": "about.partner",
    "privacy": "about.privacy",
    "tos": "about.tos"
  },
  "acl": {
    "not-omni": "Your current logged-in user has unsufficient rights to access this Application. Omni-Admin is necessary."
  },
  "app": {
    "about": "app.about",
    "title": "app.title"
  },
  "applications": {
    "accessGrantedOrganizations": "",
    "accessGrantedProfiles": "",
    "addLicensedOrganization": "",
    "clientId": "",
    "create": "",
    "edit": "",
    "licensedOrganization": {
      "notAfter": "",
      "notBefore": ""
    },
    "licensedOrganizations": "",
    "licensedOrganizationsCount": "",
    "name": "",
    "uri": "applications.uri"
  },
  "auth": {
    "change-profile": "change Profile to",
    "login": "Login",
    "logout": "auth.logout",
    "other-account": "Re-Login with other account"
  },
  "authClients": {
    "clientId": "",
    "clientName": "authClients.clientName",
    "clientSecret": "authClients.clientSecret",
    "create": "",
    "edit": "",
    "grantTypes": "",
    "postLogoutRedirectUris": "",
    "redirectUris": "",
    "responseTypes": "",
    "scope": "",
    "tokenEndpointAuthMethod": ""
  },
  "BP aktivieren": "BP aktivieren",
  "BP deaktivieren": "BP deaktivieren",
  "change password": "",
  "common": {
    "about": "common.about",
    "add": "add {{type}}",
    "app-about": "Central administration, management of accounts and roles",
    "app-title": "PIM Admin",
    "cancel": "Cancel",
    "confirm": "common.confirm",
    "dbErrorToastText": "common.dbErrorToastText",
    "delete": "Delete",
    "deleteType": "delete {{type}}",
    "disconnect": "",
    "errorToastText": "common.errorToastText",
    "save": "common.save",
    "select": {
      "organization": ""
    },
    "successCreateToastText_one": "common.successCreateToastText",
    "successCreateToastText_other": "common.successCreateToastText",
    "successDeleteToastText_one": "common.successDeleteToastText",
    "successDeleteToastText_other": "common.successDeleteToastText",
    "successDuplicateToastText_one": "common.successDuplicateToastText",
    "successDuplicateToastText_other": "common.successDuplicateToastText",
    "successSaveToastText_one": "common.successSaveToastText",
    "successSaveToastText_other": "common.successSaveToastText",
    "successToastText": "common.successToastText",
    "successUpdateToastText_one": "common.successUpdateToastText",
    "successUpdateToastText_other": "common.successUpdateToastText"
  },
  "dashboard": {
    "title": "Dashboard"
  },
  "delete": {
    "abort": "",
    "confirm": "delete.confirm",
    "confirmText": "",
    "title": ""
  },
  "federatedClients": {
    "clientId": "federatedClients.clientId",
    "clientSecret": "federatedClients.clientSecret",
    "issuer": "federatedClients.issuer",
    "responseTypes": "federatedClients.responseTypes"
  },
  "form": {
    "submit": "submit",
    "submitting": "submitting"
  },
  "groups": {
    "edit": "groups.edit",
    "editUsers": "",
    "title": ""
  },
  "IPHIS aktivieren": "IPHIS aktivieren",
  "IPHIS deaktivieren": "IPHIS deaktivieren",
  "not-implemented": "This function is not yet implemented",
  "organizations": {
    "title": "Organisationen"
  },
  "organizationSelect": {
    "placeholder": ""
  },
  "pageNotFound": {
    "title": "Die Seite konnte nicht gefunden werden"
  },
  "password": {
    "confirmNewPasswordLabel": "",
    "newPasswordLabel": "",
    "oldPasswordLabel": "",
    "required": "",
    "tooShort": ""
  },
  "planung": {
    "app": "planung.app",
    "enabled": "planung.enabled",
    "solver": "planung.solver",
    "substitution": "planung.substitution",
    "teachingload": "planung.teachingload",
    "timetable": "planung.timetable"
  },
  "Planung aktivieren": "Planung aktivieren",
  "Planung deaktivieren": "Planung deaktivieren",
  "products": {
    "planung": "products.planung"
  },
  "profiles": {
    "create": "",
    "edit": "",
    "onDeleteConfirmText": "",
    "roles": {
      "groups": {
        "add": "",
        "relation": ""
      },
      "profiles": {
        "add": "",
        "relation": ""
      }
    }
  },
  "properties": {
    "add": "",
    "title": "Properties"
  },
  "propertyName": "",
  "propertyScope": "",
  "propertyValue": "",
  "roles": {
    "title": "",
    "type": ""
  },
  "settings": {
    "title": "Einstellungen"
  },
  "shadow": {
    "and": "",
    "conditions": {
      "select": ""
    },
    "optIn": "",
    "or": "",
    "profiles": {
      "add-organization": ""
    },
    "remove": "",
    "shadowProfilesFrom": "shadow.shadowProfilesFrom",
    "shadowProfilesTo": "",
    "shadowsProfilesTo": ""
  },
  "TK-Planung": "TK-Planung",
  "users": {
    "inviteEmailSendSuccessToastText": "users.inviteEmailSendSuccessToastText",
    "title": "users.title"
  },
  "VPO aktivieren": "VPO aktivieren",
  "VPO deaktivieren": "VPO deaktivieren"
}
